
export const noteChangeAction = function (note, question, form, test) {
    return {
        type: "CHANGE_NOTE",
        payload: note,
        question: question,
        form: form,
        test: test
    }
}

export const addNotesAction = function (form, test) {
    return {
        type: "ADD_NOTES",
        payload: form,
        test: test,
    }
}


// WEBPACK FOOTER //
// ./src/redux/creators/notes.js